import { getPotentialTalentArray, curvePickForReply } from '../Jacques';
import { getFuturePotentialCategory } from './employees';
import { DEFAULT_POTENTIAL_RULESET } from './potentialDSL';
import { withLanguage } from '../components/common/Texts';

function resolveLevelSublevel(reply) {
    if (reply.level_calc == null) {
        return { level: reply.level_label, sublevel: reply.sublevel_label };
    }
    return { level: reply.level_calc, sublevel: reply.sublevel_calc };
}

export function getJacquesPotential(reply, language) {
    const { level, sublevel } = resolveLevelSublevel(reply);
    const numericLevel = Number(level);
    if (!Number.isFinite(numericLevel) || !sublevel) return null;
    const tr = withLanguage(language);
    const [nivelPotencial, tuCurva, progresionJacques, edadRangoActual] =
        getPotentialTalentArray(reply.age_at_reply, numericLevel + sublevel, tr,
            curvePickForReply(reply.created_date));
    return {
        level: numericLevel,
        sublevel,
        nivelPotencial,
        tuCurva,
        progresionJacques,
        edadRangoActual,
    };
}

export function isHighPotential(reply, ruleset, language) {
    const pot = getJacquesPotential(reply, language);
    if (!pot) return false;
    const effective = ruleset || DEFAULT_POTENTIAL_RULESET;
    return getFuturePotentialCategory(pot.nivelPotencial, pot.tuCurva, effective) === 'HIGH';
}
